import React, {Component} from 'react';
import {gpn} from "../GPN"
import Icon from "./MUI/Icon";

class Back extends Component {

    state = {};

    render() {
        return (
            <div className="back">
                <div className="btn"
                     onClick={() => this.props.navigate(-1)}><Icon i="arrow-right"/>&nbsp;<span>بازگشت</span></div>
            </div>
        );
    }
}

export default gpn(Back);